export default "/images/ic-edit.svg?d9601e887bcc8075cccf06b1eb9e1f21";